<template lang="pug">
.safety-confirm-other-users-response-rate-modal
  b-modal(v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    .safety-confirm-other-users-response-rate-modal-table
      .thead
        .header-line
          .th.type 種類
          .th.group-name グループ名
          .th.target-count 宛先人数
          .th.response-count 回答者数
          .th.non-response-count 未回答者数
          .th.response-rate 回答率
      .tbody
        .body-line(v-for="item in items")
          .td.type {{ item.groupTypeName }}
          .td.group-name {{ item.groupName }}
          .td.target-count {{ item.targetCount }}人
          .td.response-count {{ item.responseCount }}人
          .td.non-response-count {{ item.nonResponseCount }}人
          .td.response-rate {{ item.responseRate }}％
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 施設関係者 施設関係者グループ毎の回答率モーダル
 */
@Component
export default class SafetyConfirmOtherUsersResponseRateModal extends Vue {
  /** 表示可否 */
  @Prop()
  value!: boolean;

  /** 表示対象の施設関係者グループの回答 */
  @Prop()
  items!: Array<SafetyConfirmOtherUsersResponseRateModalItem>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}

export interface SafetyConfirmOtherUsersResponseRateModalItem {
  /** グループID */
  id: number;
  /** 種類 */
  groupTypeName: string;
  /** グループ名 */
  groupName: string;
  /** 宛先人数 */
  targetCount: number;
  /** 回答者数 */
  responseCount: number;
  /** 未回答者数 */
  nonResponseCount: number;
  /** 回答率 */
  responseRate: string;
}
</script>
